<template>
  <div
    :class="
      routeName === '0'
        ? 'header-container-nocolor'
        : routeName === '2'
        ? 'header-half-container'
        : 'header-container'
    "
  >
    <div class="content">
      <div class="left-header" @click="onTabClick(0)">
        <div class="header-logo">
          <img class="image" src="@/assets/icon_header_logo.png" />
        </div>
      </div>
      <div class="right-header">
        <div class="tab-box">
          <div
            :class="active === 0 ? 'tab-item-select-home' : 'tab-item'"
            @click="onTabClick(0)"
          >
            首页
          </div>
          <div
            :class="active === 1 ? 'tab-item-select' : 'tab-item'"
            @click="onTabClick(1)"
          >
            下载
          </div>
          <div
            :class="active === 2 ? 'tab-item-select' : 'tab-item'"
            @click="onTabClick(2)"
          >
            公告
          </div>
          <div
            :class="active === 3 ? 'tab-item-select' : 'tab-item'"
            @click="onTabClick(3)"
          >
            帮助
          </div>
        </div>
        <el-popover
          v-if="isLogin"
          placement="top-end"
          width="100"
          v-model="dropMenuVisible"
        >
          <div class="popover-box">
            <div
              class="popover-item popover-top-item"
              @click="onAccountCenterClick"
            >
              账户中心
            </div>
            <div class="popover-item" @click="onTakeoutClick">退出登录</div>
          </div>
          <div class="right-header-img" slot="reference">
            <img class="image" src="@/assets/logo.png" />
          </div>
        </el-popover>
        <div v-else class="login-registered" @click="onLoginClick">
          注册/登录
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getToken, removeToken } from "@/utils/auth.js";
export default {
  name: "Header",
  props: {
    routeName: {
      type: String,
      default: "0",
    },
  },
  data() {
    return {
      active: 0,
      isLogin: false,
      dropMenuVisible: false,
    };
  },
  watch: {
    "$route.meta.title"() {
      this.updateTab()
    },
  },
  mounted() {
    this.updateTab()
  },
  methods: {
    updateTab() {
      const { name } = this.$route;
      switch (name) {
        case "Home":
          this.active = 0;
          break;
        case "Login":
          this.active = -1;
          break;
        case "AccountCenter":
          this.active = -1;
          break;
        case "DownManage":
          this.active = 1;
          break;
        case "AnnouncementCenter":
        case "AnnouncementCenterDetail":
          this.active = 2;
          break;
        case "Help":
          this.active = 3;
          break;
      }
      if (getToken()) {
        this.isLogin = true;
      }
    },
    onTabClick(index) {
      this.active = index;
      switch (index) {
        case 0: //首页
          this.$router.push("/");
          break;
        case 1: //下载
          this.$router.push("/downmanage");
          break;
        case 2: //公告中心
          this.$router.push("/announcementcenter");
          break;
        case 3: //帮助
          this.$router.push("/help");
          break;
      }
    },
    //账户中心
    onAccountCenterClick() {
      this.dropMenuVisible = false;
      this.active = -1;
      this.$router.push("/accountcenter");
    },
    //退出登录
    onTakeoutClick() {
      removeToken();
      this.dropMenuVisible = false;
      this.isLogin = false;
      this.active = 0;
      this.$router.push("/");
    },
    //登录
    onLoginClick() {
      this.$router.push("/login");
    },
  },
};
</script>

<style lang="scss" scoped>
.header-container,
.header-half-container,
.header-container-nocolor {
  background-color: #0066d6;
  padding-left: 20px;
  z-index: 999;
  position: relative;
  padding-right: 20px;
  .content {
    width: 1320px;
    padding: 0;
    margin: 0 auto;
    height: 120px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left-header {
      cursor: pointer;
      .header-logo {
        .image {
          width: 200px;
          height: 63px;
        }
      }
    }
    .right-header {
      display: flex;
      align-items: center;
      height: 100%;
      .tab-box {
        display: flex;
        height: 100%;
        .tab-item,
        .tab-item-select,
        .tab-item-select-home {
          color: rgba($color: #ffffff, $alpha: 0.8);
          font-size: 18px;
          width: 50px;
          padding-top: 48px;
          text-align: center;
          margin-left: 35px;
          cursor: pointer;
        }
        .tab-item-select {
          color: #ffffff;
          width: 50px;
          border-bottom: 3px solid #ffffff;
        }
        .tab-item-select-home {
          color: #ffffff;
          width: 50px;
        }
      }
      .login-registered {
        width: 130px;
        text-align: center;
        line-height: 50px;
        height: 50px;
        margin-left: 35px;
        cursor: pointer;
        font-size: 18px;
        color: #ffffff;
        border-radius: 25px;
        border: 1px solid #ffffff;
      }
      .right-header-img {
        margin-left: 114px;
        .image {
          cursor: pointer;
          width: 50px;
          height: 50px;
          vertical-align: middle;
          border-radius: 50%;
          background-color: #fff;
        }
      }
    }
  }
}
.header-container-nocolor {
  background-color: transparent;
}
.header-half-container {
  background-color: rgba($color: #0066d6, $alpha: 0.49);
}
</style> 
<style lang="scss">
.el-popover {
  min-width: 100px !important;
  .popover-box {
    .popover-item {
      font-size: 14px;
      padding-top: 5px;
      text-align: center;
      cursor: pointer;
    }
    .popover-top-item {
      padding-bottom: 15px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue